import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Form, Row, Col, Tab, Tabs, Modal } from "react-bootstrap";
import "./OrderOptions.scss"
import messages from "../../assets/i18n";
import { HeaderActions, LoadingSpinner, FooterActions, ToastMessage } from '../../components'
import havePermissionTo from "../../utils/havePermission";
import OrderOptionsCdTab from './tabs/OrderOptionsCdTab';
import OrderOptionsProviderTab from './tabs/OrderOptionsProviderTab';
import OrderOptionsOrderTab from './tabs/OrderOptionsOrderTab';
import OrderOptionsCompanyTab from "./tabs/OrderOptionsCompanyTab";
import OrderOptionsItemsTab from "./tabs/OrderOptionsItemsTab";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard"
import ItemList from "../../containers/ItemList/ItemList";
import _ from "lodash";

function OrderOptions(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);

    const history = useHistory();

    const context                  = useSelector(state => state.authentication.context);
    const selectedOrder            = useSelector(state => state.orders.selectedOrder);
    const isLoadingOrder           = useSelector(state => state.orders.isLoadingOrder);
    const isLoadingOrderById       = useSelector(state => state.orders.isLoadingOrderById);
    const redirectToInvoiceDetails = useSelector(state => state.orders.redirectToInvoiceDetails);
    const order                    = useSelector(state => state.orders.order);
    const newOrderToast            = useSelector(state => state.orders.newOrderToast);
    const permissions              = useSelector(state => state.authorization.permissions);
    const restoSobra               = useSelector(state => state.orders.restoSobra);
    const isLoadingRestoSobra      = useSelector(state => state.orders.isLoadingRestoSobra);
    const isLoadingRestoSobraSave  = useSelector(state => state.orders.isLoadingRestoSobraSave);
    const restoSobraToast          = useSelector(state => state.orders.restoSobraToast);
	    	    
	const pageMessages = messages[lang].orderOptionsPage
	const titlePage    = messages[lang].orderOptionsPage.title + " " + selectedOrder.data.id;

    const [disableSelection, setDisableSelection]               = useState(false);
    const [showEditInvoiceButton, setShowEditInvoiceButton]     = useState(false);

    const [showToast,           setShowToast]                   = useState(false);
    const [messageError,        setMessageError]                = useState('');
    const [messageType,         setMessageType]                 = useState('toast-success');    	
    const [showAcceptModal,     setShowAcceptModal]             = useState(false);
    const [showRestoSobraModal,     setShowRestoSobraModal]     = useState(false);
    const [showReminderModal,   setShowReminderModal]           = useState(false);
    const [disableAcceptButton, setDisableAcceptButton]         = useState(true);
    const [arrChecked, setArrChecked]                           = useState([]);
    const [objQtResto, setObjQtResto]                           = useState([]);

    const [orderRenderCount, setOrderRenderCount]               = useState(0);

    const ButtonGroupLeft = () => {
		return <>
			{ (order.status === "N" || order.status === "M") && havePermissionTo("aceite-pedido", permissions) ? (
				<ButtonStandard
					id="order_list_boxlabel_button"
					disabled={disableAcceptButton}
					text={pageMessages.confirmarCiencia}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
					onClick={() => setShowAcceptModal(true)}
				/>
			) : null}

            {havePermissionTo("resto-sobra", permissions) ? (
				<ButtonStandard
					id="order_list_resto_sobra_button"
                    disabled={order.prePo === 'Y'}
					text={pageMessages.restoSobra}
					textClass="text-3"
					className="btn btn-primary px-2 py-2 btn-light"
                    onClick={() => buscarRestoSobra(selectedOrder.data.id)}
				/>
			) : null}
		</>
	}

	const pageBack = () => {
		history.push(`/main`);
    };

    const redirect = () => {
        history.push({
            pathname: '/subcontractor-invoice',
            from: '/order-options',
        })
	}

    const changeOrderSubcontractor = (id, subcontractor) => {
        if (!subcontractor) {
            setShowEditInvoiceButton(false)
        }

        dispatch({
			type: 'UPDATE_ORDER_SUBCONTRACTOR',
            payload: {
                idPedido: id,
                utilizaSubcontratado: subcontractor
            }
		})
    }

    const aceitarPedido = (id) => {
        dispatch({
			type: 'ACEITAR_PEDIDO',
            payload: {
                idPedido: id,
            }
		})
    }

    const salvarPedidoResto = (restoSobra) => {
        dispatch({
			type: 'SAVE_RESTO_SOBRA',
            payload: {
                restoSobra
            }
		})
    }

    useEffect(() => {
        setShowToast(newOrderToast.showToast)
        setMessageError(newOrderToast.message)
        setMessageType(newOrderToast.messageType)

        if (newOrderToast.message === pageMessages.pedidoAceito) {
            setShowAcceptModal(false)
            setDisableAcceptButton(true)

            let order = selectedOrder.data

            dispatch({
                type: 'GET_ORDER_BY_ID',
                payload: {
                    orderId: order.id
                }
            })           
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [newOrderToast]);
    

    useEffect(() => {
        setShowToast(restoSobraToast.showToast)
        setMessageError(getMessage(restoSobraToast.message))
        setMessageType(restoSobraToast.messageType)

        if (restoSobraToast.messageType === "toast-success") {
            setMessageError(messages[lang].registerSuccess)
            setShowRestoSobraModal(false)
        }
        if (_.isEmpty(restoSobra)) {
            setShowRestoSobraModal(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [restoSobraToast]);

    const getMessage = (message) => {
		if (message !== null && message.includes(`[${lang}]`)){
			return message.split(`[${lang}]`)[1].split(';')[0];
		} 
        if (message !== null) {
			return message;
		}
        return "Ocorreu um erro interno"
	}

	useEffect(() => {
        setShowToast(false)

        let order = selectedOrder.data

        let conciliacaos = order.conciliacaos[order.conciliacaos.length - 1]

        if (conciliacaos && conciliacaos.statusConciliacaoComercial.id === '2' && conciliacaos.statusConciliacaoFiscal.id === '2') {
            setDisableSelection(true)
        }
        
        dispatch({
			type: 'GET_ORDER_BY_ID',
            payload: {
                orderId: order.id
            }
		})


        dispatch({
            type: 'UNSET_SELECTED_ORDER',
            payload: {
                id: null,
                data: selectedOrder.data
            }
        })

        if (selectedOrder.data.utilizaSubContratado) {
            setShowEditInvoiceButton(true)
        } else {
            setShowEditInvoiceButton(false)
        }

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        if (redirectToInvoiceDetails) {
            dispatch({
                type: 'REDIRECT_TO_SUBCONTRACTOR_INVOICE_DETAILS',
                payload: false
            })

            history.push(`/subcontractor-invoice`);
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [redirectToInvoiceDetails]);

    useEffect(() => {
        if (orderRenderCount >= 1 && order && order.id) {
            if (order.status === "N" || order.status === "M") {
                setShowReminderModal(true)
                setDisableAcceptButton(false)
            }
        } else {
            let renderCount = parseInt(orderRenderCount) + 1
            setOrderRenderCount(renderCount)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [order]);

    useEffect(() => {
        let objQtResto = {};
        if (restoSobra && restoSobra.itens && restoSobra.itens.length) {
            for (let i = 0; i < restoSobra.itens.length; i++) {
                objQtResto[restoSobra.itens[i].id] = {qtResto:restoSobra.itens[i].qtResto};
            }
        }
        setObjQtResto(objQtResto);
        // setArrChecked(toggleAllArrChecked(restoSobra, arrChecked));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [restoSobra])

    const buscarRestoSobra = (id) => {
        setShowRestoSobraModal(true);
        dispatch({
            type: 'GET_RESTO_SOBRA',
            payload: {
                orderId: id
            }
        })    
    }

    const onChangeInputValue = idItem => event => {
        let newValue = event.target.value.replace(/[^0-9]+/g, "");
        newValue = newValue && parseInt( newValue , 10);
        setObjQtResto({ 
            ...objQtResto, 
            [idItem]: {
                qtResto: newValue,
            }
        });
    }

    const getObjQtResto = idValue => (
        objQtResto && objQtResto[idValue] ? objQtResto[idValue].qtResto : ''
    )
    
    const handleAllArrChecked = () => {
        setArrChecked(toggleAllArrChecked(restoSobra, arrChecked));
    }
    
    const toggleAllArrChecked = (restoSobra, checkboxArr) => (
        checkboxArr && restoSobra && restoSobra.itens && checkboxArr.length < restoSobra.itens.length ? restoSobra.itens.map(item => item.id) : []
    )

    const headers = restoSobra && restoSobra.id ? [
        messages[lang].labelItem,
        pageMessages.volumes,
        pageMessages.pecas,
        pageMessages.total,
        pageMessages.qtdResto
    ] : [
        {
            checkbox: {
                arrChecked: arrChecked,
                handleAllArrChecked: handleAllArrChecked,
            }
        },
        messages[lang].labelItem,
        pageMessages.volumes,
        pageMessages.pecas,
        pageMessages.total,
        pageMessages.qtdResto
    ];

    // eslint-disable-next-line
    const tableList = restoSobra && restoSobra.itens && restoSobra.itens.map(item => {
        if (restoSobra.id) {
            return [
                item.codItem,
                item.qtCase,
                item.qtPacote,
                item.qtCompraTotal,
                item.qtResto
            ]
        } 
        return [
            {
                checkbox: {
                    id: item.id,
                    arrChecked: arrChecked,
                    setArrChecked: setArrChecked,
                }
            },
            item.codItem,
            item.qtCase,
            item.qtPacote,
            item.qtCompraTotal,
            {
                text: <input size={15} className="text-1" id={"qtResto_" + item.id} 
                        onChange={onChangeInputValue(item.id)} 
                        value={getObjQtResto(item.id)} />
            }
        ]
    // eslint-disable-next-line
    }) || [];

    const listSelectedItems = (restoSobra) => {
        const data = {
            pedidoId: restoSobra.pedidoId,
            nomeUsuario: context && context.nome ? context.nome : "Ambiente de desenvolvimento"
        }

        data.itens = arrChecked.map(idChecked => {
            const itemSelected = restoSobra.itens.find(item => item.id === idChecked);
            if (itemSelected) {
                return {
                    id: itemSelected.id,
                    codItem: itemSelected.codItem,
                    qtCase: itemSelected.qtCase,
                    qtCompraTotal: itemSelected.qtCompraTotal,
                    qtPacote: itemSelected.qtPacote,
                    qtResto: getObjQtResto(itemSelected.id)
                };
            } else {
                return {};
            }
        });

        return data;
    }


	return (
		<div className="order-options-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={titlePage}
			/>

            <Container className="pt-3 justify-content-start">
                <Form className="px-3">
                    <Row>
                        <Form.Group as={Col} xs={6} className="mt-1">
                            <Form.Label className="text-2">{pageMessages.utilizaSubcontratada}</Form.Label>

                            <div key={`inline-radio`} className="text-2">
                                <div key={selectedOrder.data}>
                                    <Form.Check
                                        inline
                                        label={messages[lang].yes}
                                        name="subcontractorRadio"
                                        type="radio"
                                        defaultChecked={selectedOrder.data.utilizaSubContratado}
                                        id={`inline-radio-1`}
                                        onChange={() => changeOrderSubcontractor(selectedOrder.data.id, true)}
                                        disabled={isLoadingOrder || disableSelection}
                                    />
                                    <Form.Check
                                        inline
                                        label={messages[lang].no}
                                        name="subcontractorRadio"
                                        type="radio"
                                        defaultChecked={!selectedOrder.data.utilizaSubContratado}
                                        id={`inline-radio-2`} 
                                        onChange={() => changeOrderSubcontractor(selectedOrder.data.id, false)}
                                        disabled={isLoadingOrder || disableSelection}
                                    />
                                    {
                                        showEditInvoiceButton

                                        ?

                                        <ButtonStandard
                                            id="edit_subcontractor_invoice"
                                            text={pageMessages.insertInvoiceData}
                                            textClass="text-1"
                                            className="btn-sm btn-outline-success btn-standard px-2 mr-2"
                                            onClick={redirect}
                                        />

                                        :

                                        null
                                    }

                                </div>
                            </div>
                        </Form.Group>
                    </Row>				
                </Form>
                <Tabs
                    defaultActiveKey="order"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                    >
                    <Tab eventKey="order" title={pageMessages.pedido}>
                        {   order && order.id && !isLoadingOrderById ?
                            <OrderOptionsOrderTab pedido={order}/> :
                            order.error ? 
                            <span className="text-3">
                                {pageMessages.erroBuscaPedido}
                            </span> 
                            : 
                            <LoadingSpinner />
                        }
                    </Tab>
                    <Tab eventKey="provider" title={pageMessages.fornecedor}>
                        {   order && order.id && !isLoadingOrderById ?
                            <OrderOptionsProviderTab fornecedor={order.fornecedor}/> :
                            order.error ? 
                            <span className="text-3">
                                {pageMessages.erroBuscaPedido}
                            </span> 
                            :
                            <LoadingSpinner />
                        }
                    </Tab>
                    <Tab eventKey="cd" title={pageMessages.cd}>
                        {   order && order.id && !isLoadingOrderById ?
                            <OrderOptionsCdTab localizacaoFisica={order.localizacaoFisica}/> :
                            order.error ? 
                            <span className="text-3">
                                {pageMessages.erroBuscaPedido}
                            </span> 
                            : 
                            <LoadingSpinner />
                        }
                    </Tab>
                    <Tab eventKey="company" title={pageMessages.empresa}>
                        {   order && order.id && !isLoadingOrderById ?
                            <OrderOptionsCompanyTab empresa={order.empresa}/> :
                            order.error ? 
                            <span className="text-3">
                                {pageMessages.erroBuscaPedido}
                            </span> 
                            : 
                            <LoadingSpinner />
                        }
                    </Tab>
                    <Tab eventKey="items" title={pageMessages.itens}>
                        {   order && order.id && !isLoadingOrderById ?
                            <OrderOptionsItemsTab items={order.items}/> :
                            order.error ? 
                            <span className="text-3">
                                {pageMessages.erroBuscaPedido}
                            </span> 
                            : 
                            <LoadingSpinner />
                        }
                    </Tab>
                </Tabs>

            </Container>

            <Modal
                show={showReminderModal}
                onHide={() => {setShowReminderModal(false)}}
                aria-labelledby="contained-modal-title-vcenter"
                className="reminder-modal"
                centered
            >	
                <Modal.Header className="text-left" closeButton>
                    <Modal.Title className="w-100 font-weight-bold">
                        {pageMessages.tituloModalAceitePedido}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container className="px-0 mb-0 pb-0">
                        {pageMessages.lembreteAceitePedido}
                        <Container style={{textAlign: 'center'}} className="pt-2 px-0 mb-0 pb-0">
                            <ButtonStandard
                                id="norm_save_button"
                                type="submit"
                                text={'OK'}
                                textClass="text-2"
                                className="btn-primary btn-sm btn-standard px-2 mr-2"
                                onClick={() => {setShowReminderModal(false)}}
                            />
                        </Container>                        
                    </Container>
                </Modal.Body>
            </Modal>

            <Modal
                show={showAcceptModal}
                onHide={() => { setShowAcceptModal(false) }}
                aria-labelledby="contained-modal-title-vcenter"
                className="reminder-modal"
                centered
            >	
                <Modal.Header className="text-left" closeButton>
                    <Modal.Title className="w-100 font-weight-bold">
                        {pageMessages.tituloModalAceitePedido}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container className="px-0 mb-0 pb-0">
                        {pageMessages.confirmarAceite}
                        <Container style={{textAlign: 'center'}} className="pt-2 px-0 mb-0 pb-0">
                            <ButtonStandard
                                id="norm_save_button"
                                type="submit"
                                text={pageMessages.aceitarPedido}
                                textClass="text-2"
                                className="btn-primary btn-sm btn-standard px-2 mr-2"
                                isLoading={isLoadingOrder}
                                onClick={() => aceitarPedido(selectedOrder.data.id)}
                            />
                        </Container>                        
                    </Container>
                </Modal.Body>
            </Modal>

            <Modal
                show={showRestoSobraModal}
                onHide={() => { setShowRestoSobraModal(false) }}
                aria-labelledby="contained-modal-title-vcenter"
                className="resto-sobra-modal"
                centered
            >	
                <Modal.Header className="text-left" closeButton>
                    <Modal.Title className="w-100 font-weight-bold">
                        {restoSobra.id ? pageMessages.tituloModalRestoSobraVisualizar : pageMessages.tituloModalRestoSobraCriar}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container className="px-0 mb-0 pb-0">
                        {  !isLoadingRestoSobra ? 
                            <>
                                <Container className="mb-5 pb-5">
                                    { restoSobra.id ? 
                                        <Row>
                                            <Form.Group as={Col} className="ml-3">
                                                <Form.Label className="text-2">{pageMessages.nomeUsuario}</Form.Label>
                                                <Form.Control
                                                    className="text-2 border-radius-full"
                                                    type="text"
                                                    defaultValue={restoSobra.nomeUsuario}
                                                    readOnly={true}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} className="mr-3">
                                                <Form.Label className="text-2">{pageMessages.dataCadastro}</Form.Label>
                                                <Form.Control
                                                    className="text-2 border-radius-full"
                                                    type="text"
                                                    defaultValue={restoSobra.dataCadastro}
                                                    readOnly={true}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} className="mr-3">
                                                <Form.Label className="text-2">{pageMessages.pedidoResto}</Form.Label>
                                                <Form.Control
                                                    className="text-2 border-radius-full"
                                                    type="text"
                                                    defaultValue={restoSobra.pedidoResto}
                                                    readOnly={true}
                                                />
                                            </Form.Group>
                                        </Row>
                                        : <></>
                                    }
                                    <ItemList header={headers} titleTable={pageMessages.restoSobraTable} listTable={tableList} />
                                </Container>
                                <Container style={{textAlign: 'center'}} className="pt-2 px-0 mb-0 pb-0">
                                    { restoSobra.id ? 
                                    <></> 
                                    : 
                                    <ButtonStandard
                                        id="norm_save_button"
                                        type="submit"
                                        text={pageMessages.botaoRestoSobra}
                                        textClass="text-2"
                                        className="btn-primary btn-sm btn-standard px-2 mr-2"
                                        isLoading={isLoadingRestoSobraSave}
                                        disabled={isLoadingRestoSobraSave}
                                        onClick={() => salvarPedidoResto(listSelectedItems(restoSobra))}
                                    />}
                                </Container>
                            </>
                            : 
                            <Container className="mt-2 pt-3 mb-5 pb-5">
                                <LoadingSpinner />
                            </Container>
                        }                     
                    </Container>
                </Modal.Body>
            </Modal>

            <FooterActions ButtonGroupLeft={ButtonGroupLeft}/>

		</div>
	)
}

export default withRouter(OrderOptions);